import script from "./IntervalsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./IntervalsStep.vue?vue&type=script&setup=true&lang=js"

import "./IntervalsStep.vue?vue&type=style&index=0&id=cdf709da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdf709da"]])

export default __exports__